const GET_VENDOR_DETAILS = 'GET_VENDOR_DETAILS';
const SET_VENDOR_DETAILS = 'SET_VENDOR_DETAILS';

export {
    GET_VENDOR_DETAILS,
    SET_VENDOR_DETAILS
};
